import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Routes from './routes';
import { injectGlobal } from 'styled-components';

export const globalInjectedStyle = injectGlobal`
	body {
		overflow: hidden;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		top: 0;
		margin: 0;
		padding: 0;
		font-family: "Roboto", sans-serif;
		font-weight: 400;
		font-size: 14px;
	}

	.__react_component_tooltip {
		margin: 0!important;
		padding: 0!important;
		background: none!important;
	}

	.__react_component_tooltip:before,
	.__react_component_tooltip:after {
		content: none!important;
	}

	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(./.gallery/static/media/Roboto-Light.ttf) format('truetype');
	}

	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(./.gallery/static/media/Roboto-Regular.ttf) format('truetype');
	}

	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: url(./.gallery/static/media/Roboto-Medium.ttf) format('truetype');
	}

	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(./.gallery/static/media/Roboto-Bold.ttf) format('truetype');
	}

	svg { // on edge, can't click on the button behind the button icon without this line
		pointer-events: none;
	}
`;

ReactDOM.render(
	<Routes/>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx